import { ResponseError } from 'shared/errors/responseError';
import { IOfferTooltipData } from 'shared/types';

import { IGetOfferPinPopupRequestSchema } from '../../repositories/countryside-search/entities/entities/GetOfferPinPopupRequestSchema';
import {
  fetchGetOfferPinPopup,
  TGetOfferPinPopupResponse,
} from '../../repositories/countryside-search/v1/get-offer-pin-popup';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchGenplanOffer(
  context: IApplicationContext,
  parameters: IGetOfferPinPopupRequestSchema,
): Promise<IOfferTooltipData> {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: TGetOfferPinPopupResponse = await fetchGetOfferPinPopup({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchGenplanOffer',
        message: `${response.message}`,
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    return response.offerPinPopup;
  } catch (error) {
    logger.warning(error, { degradation: 'Превью оффера на генплане' });

    throw error;
  }
}
